import {
  Directive,
  Input,
  OnInit,
  ViewContainerRef
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../interfaces/field.interface";
import { InputComponent } from "../../components/dynamic-field-component/input/input.component";
import { ButtonComponent } from "../../components/dynamic-field-component/button/button.component";
import { SelectComponent } from "../../components/dynamic-field-component/select/select.component";
import { DateComponent } from "../../components/dynamic-field-component/date/date.component";
import { CheckboxComponent } from "../../components/dynamic-field-component/checkbox/checkbox.component";
import { DividerComponent } from "../../components/dynamic-field-component/divider/divider.component";
import { InputMaskComponent } from "../../components/dynamic-field-component/input-mask/input-mask.component";
import { TextAreaComponent } from "../../components/dynamic-field-component/text-area/text-area.component";
import { TermoComponent } from "../../components/dynamic-field-component/termo/termo.component";
import { MultipleSelectComponent } from "../../components/dynamic-field-component/multiple-select/multiple-select.component";
import { ProfissaoSelectComponent } from "../../components/dynamic-field-component/profissao-select/profissao-select.component";
import { EnderecoComponent } from "../../components/dynamic-field-component/endereco/endereco.component";

type ComponentMapper = {
  [key: string]: any;
};

const componentMapper: ComponentMapper = {
  input: InputComponent,
  button: ButtonComponent,
  select: SelectComponent,
  date: DateComponent,
  checkbox: CheckboxComponent,
  divider: DividerComponent,
  inputmask: InputMaskComponent,
  textarea: TextAreaComponent,
  termo: TermoComponent,
  multiselect: MultipleSelectComponent,
  profissaoselect: ProfissaoSelectComponent,
  endereco: EnderecoComponent,
};
@Directive({
  selector: "[dynamicField]",
  standalone: true
})
export class DynamicFieldDirective implements OnInit {
  @Input()
  field: FieldConfig;

  @Input()
  group: FormGroup;
  @Input() isSubmitting = false;

  componentRef: any;

  constructor(
    private container: ViewContainerRef
  ) { }
  ngOnInit() {
    const component = this.container.createComponent(componentMapper[this.field.type]);
    this.componentRef = component;
    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;

    if ('isSubmitting' in this.componentRef.instance) {
      this.componentRef.instance.isSubmitting = this.isSubmitting;
    }
  }
}